// 封装操作 localStorage 本地存储的方法

const PROJECT_ID = 'caihang_project'; // 项目唯一标识

const storage = {
    // 添加前缀的辅助方法
    getKey(key) {
        return `${PROJECT_ID}_${key}`;
    },

    // 设置缓存，自动添加项目前缀
    set(key, value) {
        localStorage.setItem(this.getKey(key), JSON.stringify(value));
    },

    // 获取缓存，自动添加项目前缀
    get(key) {
        return JSON.parse(localStorage.getItem(this.getKey(key)));
    },

    // 删除缓存，自动添加项目前缀
    remove(key) {
        localStorage.removeItem(this.getKey(key));
    },

    // 清除当前项目所有缓存
    clearProject() {
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith(PROJECT_ID)) {
                localStorage.removeItem(key);
            }
        });
    },

    // 判断是否存在某个缓存
    has(key) {
        return !!localStorage.getItem(this.getKey(key));
    }
}

export default storage;



// WEBPACK FOOTER //
// ./src/model/storage.js